import type { Person, UpdatePersonPayload } from '@/types/person';

export interface PersonMarkAsUnknownUpdate {
    payload: UpdatePersonPayload;
    optimisticPatch: Partial<Person>;
}

export function getPersonMarkAsUnknownUpdate(): PersonMarkAsUnknownUpdate {
    return {
        payload: { name: null, tags: [] },
        optimisticPatch: { name: '', tags: [], known: false },
    };
}

export function markingAsUnknownRemovesTags(person: Person): boolean {
    return person.tags.length > 0;
}
